/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Vuex from 'vuex';

import VuexReset from '@ianwalter/vuex-reset';

import getters from './getters';
import mutations from './mutations';

import campaigns from '@/modules/campaigns/store';
import content from '@/modules/content/store';
import authentication from '@/modules/authentication/store';
import account from '@/modules/account/store';
import reporting from '@/modules/reporting/store';
import showcase from '@/modules/showcase/store';
import share from '@/modules/share/store';
import templates from '@/modules/templates/store';
import trackers from '@/modules/trackers/store';
import reportsGenerator from '@/modules/ReportsGenerator/store';

import coreApi from '@/core/coreApi';
import * as types from './types';

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [VuexReset()],
  modules: {
    authentication,
    campaigns,
    content,
    account,
    reporting,
    showcase,
    share,
    templates,
    trackers,
    reportsGenerator,
  },
  state: {
    globalMessage: {
      type: '',
      message: '',
    },
    currencyMap: {},
  },
  getters,
  actions: {
    [types.FETCH_COMPANY_LOGO]: (context, domain) => coreApi
      .getCompanyLogo(domain)
      .then((logoIamgeUrl) => logoIamgeUrl),
  },
  mutations,
});
export default store;
